import { css } from '@emotion/react';

export default css`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 0 0 3rem 1rem;
`;